import { render, staticRenderFns } from "./PeriodListItem.vue?vue&type=template&id=3be45083&scoped=true"
import script from "./PeriodListItem.vue?vue&type=script&lang=ts"
export * from "./PeriodListItem.vue?vue&type=script&lang=ts"
import style0 from "./PeriodListItem.vue?vue&type=style&index=0&id=3be45083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be45083",
  null
  
)

export default component.exports